// @ts-strict-ignore
import { NewsLink } from '../FeaturedItem'
import { getFormattedDate } from '../getFormattedDate'
import LocalizedLink from '@components/Localization/LocalizedLink'
import { Box, OldHeading, Image, OldText } from '@gassan-ui'
import { getUrlSlugInLocale } from '@lib/get-url-slug-in-locale'
import { Item, getKontentImage } from '@lib/kontent'
import { NewsItem } from '@lib/kontent/models/NewsItem'
import { useTranslation } from 'next-i18next'
import { FC } from 'react'

type Props = Item<NewsItem> & {
  isRegular: boolean
}

const Idle: FC<Props> = ({ elements, isRegular }) => {
  const {
    i18n: { language },
  } = useTranslation()
  const image = isRegular
    ? elements.small_image_variant.value[0]
    : elements.wide_image_variant.value[0]
  return (
    <LocalizedLink href={`/${getUrlSlugInLocale('newsPage', language)}/${elements.url_slug.value}`}>
      <NewsLink>
        <Box mb="1.5rem">
          <Image
            className={isRegular ? 'aspect-[20/11]' : 'aspect-[20/9]'}
            sources={[
              getKontentImage(image.url, {
                width: 600,
              }),
              getKontentImage(image.url, {
                width: 600,
              }),
              getKontentImage(image.url, {
                width: 600,
              }),
              getKontentImage(image.url, {
                width: 1000,
              }),
            ]}
            alt={image.description}
            placeholderSrc={getKontentImage(image.url, {
              width: 50,
            })}
          />
        </Box>
        <Box>
          <OldHeading variant="h4" as="h3" mb="1rem">
            {elements.title.value}
          </OldHeading>
          <OldText color="shades.500" mb="0">
            {getFormattedDate(elements.publication_date.value, language)}
          </OldText>
        </Box>
      </NewsLink>
    </LocalizedLink>
  )
}

export default Idle
